import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import HaloNav from './components/HaloNav'; 

import Hero from './components/Hero';
import Capabilities from './components/Capabilities';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import SmoothScroll from './components/SmoothScroll';
import ProjectDetails from './components/ProjectDetails';
import Labs from './components/Labs';
import Leadership from './components/Leadership';
import AbrahamBio from './components/AbrahamBio';
import Legal from './pages/Legal';
import Isho from './pages/Isho';
import BaseApp from './pages/BaseApp';
import BasePrivacy from './pages/BasePrivacy';
import BaseTos from './pages/BaseTos';
import Footer from './components/Footer';

// Page Components
const Home = () => (
  // The persistent editorial grid shell
  <main className="relative w-full min-h-screen flex flex-col z-10 grid-sys max-w-[1920px] mx-auto border-x border-border">
    {/* All sections will now place themselves on the 12-col grid */}
    <div className="col-span-12">
        <Hero />
    </div>
    <div id="projects" className="col-span-12 border-t-brut">
        <Capabilities />
    </div>
    <div className="col-span-12 border-t-brut">
        <Projects />
    </div>
    <div className="col-span-12 border-t-brut grid-sys">
        {/* About and Contact will share the bottom grid space like the reference */}
        <div id="about" className="col-span-12 md:col-span-6 border-b-brut md:border-b-0 md:border-r-brut">
            <About />
        </div>
        <div id="contact" className="col-span-12 md:col-span-6">
            <Contact />
        </div>
    </div>
  </main>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <Router>
            <SmoothScroll>
              <div className="bg-background text-foreground min-h-screen selection:bg-accent selection:text-white font-sans antialiased overflow-x-hidden relative">

              {/* Application Foreground Layer */}
              <div className="relative z-10 w-full min-h-screen flex flex-col">
                <HaloNav />
                
                <AnimatePresence mode="wait">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/labs" element={<Labs />} />
                    <Route path="/leadership" element={<Leadership />} />
                    <Route path="/leadership/abraham" element={<AbrahamBio />} />
                    <Route path="/project/:id" element={<ProjectDetails />} />
                    <Route path="/legal" element={<Legal />} />
                    <Route path="/isho" element={<Isho />} />
                    <Route path="/base" element={<BaseApp />} />
                    <Route path="/base/privacy" element={<BasePrivacy />} />
                    <Route path="/base/tos" element={<BaseTos />} />
                  </Routes>
                </AnimatePresence>

                <Footer />
              </div>

            </div>
          </SmoothScroll>
        </Router>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
